import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconFaceSad = ({ size = 18, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M9 10h.01M15 10h.01' strokeWidth='2.8' />
      <path d='M8.5 16.5a4 3 0 0 1 7 0' />
    </g>
  </SDIcon>
)

export default IconFaceSad
